document.addEventListener('DOMContentLoaded', () => {

  window.cartIsOpen = false;

  const cartOverlay = document.querySelector(".cart-drawer-overlay");
  const closeCartIcon = document.querySelector(".js-drawer .js-close");
  const cartDrawerSection = document.querySelector(
    "#shopify-section-cart-drawer"
  );

  const closeElements = [closeCartIcon, cartOverlay];
  const closeElementsSet = new Set(closeElements);

  const isElementOrParentInSet = (element, elementSet) => {
    for (let setElement of elementSet) {
      if (setElement === element || setElement.contains(element)) {
        return true;
      }
    }

    return false;
  }

  const updateCartStatus = () => {
    setTimeout(() => {
        window.cartIsOpen = cartDrawerSection.querySelector(".cart-drawer-outer").classList.contains("is-active");
        if (window.cartIsOpen){
          window._conv_q = window._conv_q || [];
          window._conv_q.push(["executeExperiment","100488643"]) 
        }
    }, 500);
  };

  document.addEventListener('click', (evt) => {
    if (isElementOrParentInSet(evt.target, closeElementsSet)) {
        updateCartStatus();
    }
  });

  subscribe(PUB_SUB_EVENTS.cartRender, updateCartStatus);
});